"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSS = function FlagSS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123.18)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123.18)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.63",
    width: "409.6",
    height: "89.44",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.68-6.09l4.2,9.11,9.73-2.4a.73.73,0,0,1,.83,1l-4.5,9,7.94,6.12a.73.73,0,0,1-.29,1.3l-9.82,2.06.18,10a.74.74,0,0,1-1.2.58l-7.74-6.39-7.73,6.39a.74.74,0,0,1-1.2-.58l.17-10L-135.92,18a.73.73,0,0,1-.3-1.3l7.95-6.12-4.51-9a.73.73,0,0,1,.83-1l9.74,2.4,4.2-9.11a.73.73,0,0,1,1.33,0Zm0,0",
    transform: "translate(194 123.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "85.93",
    width: "409.6",
    height: "12.01",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "172.79",
    width: "409.6",
    height: "12.01",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.7,144.45-6.44,15.07a3.53,3.53,0,0,0,0-5.78L-190.7-120.09a7,7,0,0,0-2.3,5.15V139.3a7,7,0,0,0,2.3,5.15Zm0,0",
    transform: "translate(194 123.18)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134.15-20.74-118.29-4.5l20.5-9.76a3.06,3.06,0,0,1,4,4.18L-104.31,10l15.62,16.48a3.06,3.06,0,0,1-2.74,5.12l-22.38-3.81-10.85,19.94a3.06,3.06,0,0,1-5.71-1l-3.29-22.46L-156,20.12a3.06,3.06,0,0,1-.79-5.75L-136.43,4.3l-2.94-22.51a3.06,3.06,0,0,1,5.22-2.53Zm0,0",
    transform: "translate(194 123.18)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSS;
exports["default"] = _default;